"use client";

import { useAppSession } from "@/src/lib/clientHooks/userHooks";
import { AppHeader } from "../internal/app-header";
import { WebHeader } from "../web/web-header";

export function DocsTopbar() {
  const { status } = useAppSession();

  if (status === "authenticated") {
    return <AppHeader showSidebarTrigger={false} className="border-b" />;
  }

  return <WebHeader className="p-4 border-b" />;
}
